import {
  API_FETCH_MENU,
  API_FETCH_MENU_SUCCESS,
  ADD_ITEM_MENU,
  ADD_ITEM_MENU_SUCCESS,
  REMOVE_ITEM_MENU,
  REMOVE_ITEM_MENU_SUCCESS,
  GENERATE_LOGIN_OTP_SUCCESS,
  SEND_LOGIN_OTP_SUCCESS,
  API_FETCH_USER_SUCCESS,
  API_FETCH_USER,
  SET_SELECTED_CATEGORY,
  PLACE_ORDER,
  PLACE_ORDER_SUCCESS,
  CLEAR_CART,
  LOGIN_GUEST_USER,
  FETCH_REORDER_REQUEST,
  FETCH_REORDER_SUCCESS,
  ADD_TO_CART_FROM_REORDER,
  FETCH_BILL_SUCCESS,
  FETCH_BILL_REQUEST,
  SUBMIT_PAYMENT,
  PAYMENT_VERIFIED,
  SEND_WAITER_REQUEST,
  SEND_WAITER_REQUEST_SUCCESS,
  START_SIGNALR,
  LOGOUT_SUCCESS,
  ADD_NOTE,
} from "./constant";

export const apiCallRequest = () => ({
  type: "API_CALL_REQUEST",
});

export const apiCallSuccess = (data) => ({
  type: "API_CALL_SUCCESS",
  payload: data,
});

export const apiCallFailure = (error) => ({
  type: "API_CALL_FAILURE",
  payload: error,
});

// SAGA
export const fetchUsers = (data) => ({
  type: API_FETCH_USER,
  payload: data,
});

export const fetchUsersSuccess = (data) => ({
  type: API_FETCH_USER_SUCCESS,
  payload: data,
});

// SAGA
export const fetchMenuData = (data) => ({
  type: API_FETCH_MENU,
  payload: data,
});

export const fetchMenuDataSuccess = (data) => ({
  type: API_FETCH_MENU_SUCCESS,
  payload: data,
});

export const addItem = (data) => ({
  type: ADD_ITEM_MENU,
  payload: data,
});

export const addNote = (data) => ({
  type: ADD_NOTE,
  payload: data,
});

export const sendWaiterRequest = (data) => ({
  type: SEND_WAITER_REQUEST,
  payload: data,
});

export const sendWaiterRequestSuccess = (data) => ({
  type: SEND_WAITER_REQUEST_SUCCESS,
  payload: data,
});

export const loginSuccess = (user) => ({
  type: SEND_LOGIN_OTP_SUCCESS,
  payload: user,
});

export const generateOTPSuccess = (data) => ({
  type: GENERATE_LOGIN_OTP_SUCCESS,
  payload: Boolean(data),
});

export const placeOrder = (data) => ({
  type: PLACE_ORDER,
  payload: data,
});

export const placeOrderSuccess = (user) => ({
  type: PLACE_ORDER_SUCCESS,
  payload: user,
});

export const clearCart = () => ({
  type: CLEAR_CART,
});

export const addItemSuccess = (data) => ({
  type: ADD_ITEM_MENU_SUCCESS,
  payload: data,
});
export const removeItem = (data) => ({
  type: REMOVE_ITEM_MENU,
  payload: data,
});

export const removeItemSuccess = (data) => ({
  type: REMOVE_ITEM_MENU_SUCCESS,
  payload: data,
});

export const setSelectedCategory = (categoryId) => ({
  type: SET_SELECTED_CATEGORY,
  payload: categoryId,
});

export const guestLogin = (data) => ({
  type: LOGIN_GUEST_USER,
  payload: data,
});

export const fetchReorder = (data) => ({
  type: FETCH_REORDER_REQUEST,
  payload: data,
});

export const fetchReorderSuccess = (data) => ({
  type: FETCH_REORDER_SUCCESS,
  payload: data,
});

export const addToCartFromReorder = (item) => ({
  type: ADD_TO_CART_FROM_REORDER,
  payload: item,
});

export const fetchBill = (data) => ({
  type: FETCH_BILL_REQUEST,
  payload: data,
});

export const fetchBillSuccess = (data) => ({
  type: FETCH_BILL_SUCCESS,
  payload: data,
});

export const submitPayment = (bill, billItems) => ({
  type: SUBMIT_PAYMENT,
  payload: { bill, billItems },
});

export const startSignalR = (data) => ({
  type: START_SIGNALR,
  payload: data,
});

export const paymentVerified = () => ({
  type: PAYMENT_VERIFIED,
});

export const logoutSuccess = () => ({
  type: LOGOUT_SUCCESS,
});
